export default str => str == 0 ? 0 : Number(str).toFixed(2);
